export enum FeatureFlagId {
  USE_PORTAL_CHAT = 'USE_PORTAL_CHAT',
  SHOW_MESSAGES_POPUP = 'SHOW_MESSAGES_POPUP',
  USE_NEW_STATISTICS = 'USE_NEW_STATISTICS',
  USE_HEALTH_PROGRAM = 'USE_HEALTH_PROGRAM',
}

export type FeatureFlags = Record<string, string>
